import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import StudentProgressSummaryAdminEnd from "./routes/StudentProgressSummaryAdminEnd";
export default store => ({
  path: "students",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(/* webpackChunkName: "admin-gradebook" */ "./components"),
      ]).then(([importedModule0]) => {
        const component = importedModule0.default;
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [StudentProgressSummaryAdminEnd(store)],
});
